// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import BaseStore from '../../components/base/base-store';
import { IDialogOptions } from './dialogs-actions';
import _ from 'lodash';

export interface IStoredDialogState<T> {
    visible: boolean;
    processing: boolean;
    zIndexShift: number;
    containerHeight?: number;
    step?: string;
    prevSteps?: { step: string; containerHeight: number }[];
    error?: string;
    initialOptions: IDialogOptions<T>;
    data: T;
}

export interface IDialogsStoreState {
    [dialogId: string]: IStoredDialogState<any>;
}

let guid = 1;
class DialogStore extends BaseStore<IStoredDialogState<any>> {
    public dispatcherEvents: string = '_';

    public initialState: any;

    public updateState(newState: any): void {
        // no throttling here!
        this.innerUpdateState(newState);
    }

    // tslint:disable-next-line:member-ordering (autogenerated)
    constructor() {
        super();
        this.initialize('DialogStore' + guid++);
    }
}

// tslint:disable-next-line:max-classes-per-file (autogenerated)
class DialogsStore extends BaseStore<IDialogsStoreState> {
    public dispatcherEvents: string = 'setDialogsState';

    public initialState: any = {};

    private personalStores: { [formId: string]: DialogStore } = {};

    public updateState(newState: any): void {
        // no throttling here!
        this.innerUpdateState(newState);
    }

    // tslint:disable-next-line:typedef (autogenerated)
    protected innerUpdateState(newState: any) {
        const currentState = this.getImmediateState();
        const changedFormIds = _.filter(_.keys(newState), (formId: string) => {
            return newState[formId] !== currentState[formId];
        });
        super.innerUpdateState(newState);
        _.forEach(changedFormIds, (formId: string) => {
            // tslint:disable-next-line:no-shadowed-variable (autogenerated)
            const store = this.personalStores[formId];
            if (store) {
                store.updateState(newState[formId]);
            }
        });
    }

    // tslint:disable-next-line:typedef (autogenerated)
    public getDialogStore(dialogId: string) {
        if (!this.personalStores[dialogId]) {
            this.personalStores[dialogId] = new DialogStore();
            const storedState = this.getImmediateState()[dialogId];
            this.personalStores[dialogId].updateState(storedState);
        }
        return this.personalStores[dialogId];
    }

    // tslint:disable-next-line:member-ordering (autogenerated)
    constructor() {
        super();
        this.initialize('DialogsStore');
    }
}

const store = new DialogsStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
